import styled from 'styled-components'

export const Container = styled.div`
    padding: 10px;
    display: flex;
    
    background: #fff;

    .CenterDiv {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
    }

    .LeftDiv, .RightDiv {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;

        .OperationType {
            font-style: normal;
            font-weight: 400;
            font-size: 11px;
            line-height: 14px;
            color: #606a80;
    
            .Label {
                position: relative;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                color: #364159;
                border-bottom: 1px solid #364159;
                margin-bottom: 5px;
                padding-bottom: 2px;
                width: 75px;
            }
    
            .Number {
                &:not(span) {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 16px;
                }
            }
        }
    }

    .LeftDiv {
        align-items: flex-end;
    }
`

export const ValueSpan = styled.span`
    font-weight: 600;
    font-size: 22px;
    line-height: 22px;
    color: ${({ color }) => color || '#000'};
`

export const Line = styled.div`
    background: #000;
    height: 1px;
    width: ${({ length }) => length || 0}px;
    position: absolute;
    left: ${({ toLeft }) => toLeft ? 0 : 75}px;
    bottom: -1px;
    transform: rotate(${({ rotate }) => rotate || 0}deg) scaleX(${({ toLeft }) => toLeft ? -1 : 1});
    transform-origin: top left;

    &:after {
        position: absolute;
        content: "";
        width: 10px;
        height: 10px;
        background: ${({ color }) => color || '#000'};
        right: -5px;
        top: -5px;
        border-radius: 50%;
        border: 2.5px solid rgba(255, 255, 255, 0.25);
    }
`
